"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const MergedOfferLabelsView = ({ listingOffer, }) => react_1.default.createElement("div", { className: "labels" },
    listingOffer.simpleOfferList.hasAnySimpleOfferWinterTires()
        && react_1.default.createElement("span", { className: "label label--winter-tires", title: "V\u010Detn\u011B zimn\u00EDch pneumatik" }, "V\u010Detn\u011B zimn\u00EDch pneumatik"),
    listingOffer.simpleOfferList.isAnySimpleOfferAvailableSooner()
        && react_1.default.createElement("span", { className: "label label-available-sooner", title: "Jezd\u00EDte do 3 dn\u016F" }, "Jezd\u00EDte do 3 dn\u016F"));
exports.default = MergedOfferLabelsView;
